import React from 'react';
import { FiCpu, FiHardDrive, FiWifi, FiDatabase, FiLayers, FiGrid } from 'react-icons/fi';
import './TechSolutions.css';

const solutions = [
  { icon: <FiCpu size={18} />, label: 'IT Platform' },
  { icon: <FiHardDrive size={18} />, label: 'HCI Solution' },
  { icon: <FiWifi size={18} />, label: 'IoT Ecosystem' },
  { icon: <FiDatabase size={18} />, label: 'SD-WAN Pro' },
  { icon: <FiLayers size={18} />, label: 'API Orchid' },
  { icon: <FiGrid size={18} />, label: 'AI CloudLab' },
];

const TechSolutions = () => {
  return (
    <section className="tech section">
      <div className="container">
        <div className="tech__header">
          <span className="section-label">Our Products</span>
          <h2 className="section-title">Solusi Teknologi Terintegrasi</h2>
        </div>
      </div>

      <div className="tech__marquee">
        <div className="tech__marquee-track">
          {[...solutions, ...solutions].map((solution, index) => (
            <div key={index} className="tech__item">
              <span className="tech__item-icon">{solution.icon}</span>
              <span className="tech__item-label">{solution.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechSolutions;
